import _, { forEach } from "lodash";
import Axios from "../apis/axios";
import { produce } from "immer";
import moment from "moment";
import { NodeId } from "components/NodeId";

import { v4 as uuidv4 } from "uuid";
import mqtt from "mqtt";
import { Buffer } from "buffer";

export interface MqttOptions {
  url: string;
  username?: string;
  password?: string;
  tls: boolean;
  certValidation: boolean;
  clientId?: string;
  subscriptions: Array<Subscription>;
  certificateAuthority?: string;
  clientCertificate?: string;
  clientKey?: string;
}

export interface Subscription {
  topic: string;
  qos: QoS;
}

export type QoS = 0 | 1 | 2;

interface SubscribedEvents {
  equipment?: {
    name?: {
      de: string;
      en: string;
    };
    isequipmentof?: {
      area?:
        | {
            name?: {
              de: string;
              en: string;
            };
          }
        | undefined;
    }[];
    haseventlog?: {
      eventlog?:
        | {
            events?: any[] | undefined;
          }
        | undefined;
    }[];
  };
}

export type Event = [
  number, // timestamp
  number, // unknown
  string, // type
  number, // unknown
  string, // category
  string, // text
  number, // unknown
  string, // batchNumber
  number, // unknown
  string, // productName
  string // userName
];

export interface Logs {
  clientId: string;
  equipmentNodeId: string;
  events: Event[];
}

const initialSubscribedEvents: SubscribedEvents = {
  equipment: {
    name: {
      de: "",
      en: "",
    },
    haseventlog: [
      {
        eventlog: {
          events: [], // Provide an initial value based on your actual logic
        },
      },
    ],
    isequipmentof: [
      {
        area: {
          name: {
            de: "",
            en: "",
          }, // Provide an initial value based on your actual logic
        },
      },
    ],
  },
};

const getStartTimeStamp = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0); // Set time to 00:01 AM

  return date.getTime();
};
const getEndtimeStamp = () => {
  const dateEnd = new Date();
  dateEnd.setHours(23, 59, 59, 999); // Set time to 23:59 AM
  return dateEnd.getTime();
};
const getYesterdayStartTimestamp = () => {
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 1); // Go back one day
  currentDate.setHours(0, 0, 0, 0); // Set time to 00:00:00

  return currentDate.getTime(); // Get timestamp
};
let startTimeVar: any,
  endTimeVar = 0;
const currentDate = new Date();
currentDate.setHours(23, 59, 59, 999);
endTimeVar = currentDate.getTime();

startTimeVar = getYesterdayStartTimestamp();
let brokerConnectionClient: mqtt.MqttClient;
const createEquipmentSlice = (set: (data: any) => void, get: () => any) => ({
  subscribedEquipments: {} as any,
  _subscribedEquipments: {} as any, // for Dashboard Table

  commandInProcess: undefined,
  subscribedEvents: initialSubscribedEvents,
  maintenanceCategories: {},
  areaEqsEvents: [],
  allEventsRaw: [],
  eventPollingActive: false,
  eventsTimeRange: false,
  startTime: startTimeVar,
  endTime: endTimeVar,

  brandTypes: [],

  connectWebMQTT: async () => {
    try {
      const options = get().rabbitmqConfig;

      const client = await mqtt.connect(options.websocketurl, {
        clientId: options.clientId,
        username: options.username,
        password: options.password,
        rejectUnauthorized: options.rejectUnauthorized,
      });
      brokerConnectionClient = client;
      console.log("MQTT client connected successfully!!");
      client.subscribe(get().clientId + "/events");
      client.subscribe(get().clientId + "/kpis");

      client.on("message", (topic: any, log: Buffer) => {
        if (topic === get().clientId + "/events") {
          const logContent: Logs[] = JSON.parse(log.toString("utf8"));

          for (const obj of logContent) {
            const area = get().getAreaOfEquipment(obj.equipmentNodeId);

            // Find the correct equipment inside the area by matching nodeid
            const matchedEquipment =
              area?.hasequipment?.find(
                (eqObj: any) => eqObj.equipment?.nodeid === obj.equipmentNodeId
              )?.equipment || null;

            for (const log of obj.events) {
              const event = {
                date: moment(log[0]).format("DD.MM.YYYY / HH:mm:ss"),
                timestamp: log[0],
                description: log[5],
                meldungType: log[2] + " (" + log[3] + ")",
                interner : matchedEquipment?.name || "Unknown Equipment",
                bereich: area?.name,
                productionaline: log[9],
                status: log[4],
                equipmentNodeId: matchedEquipment?.nodeid || obj.equipmentNodeId
              };

              const isTimestampInRange = (
                timestamp: number,
                start: number,
                end: number
              ): boolean => {
                return timestamp >= start && timestamp <= end;
              };
              // Check if timestamp is in range
              const inRange = isTimestampInRange(
                log[0],
                get().startTime !== 0 ? get().startTime : getStartTimeStamp(),
                get().endTime !== 0 ? get().endTime : getEndtimeStamp()
              );

              if (
                (inRange && get().eventsTimeRange === true) ||
                get().eventsTimeRange === false
              ) {
                const tempArray = [...get().areaEqsEvents];

                tempArray.push(event);
                const areaEqsEventsFlat: any[] = tempArray.flat().flat();
                const areaEqsEventsFlatSorted = areaEqsEventsFlat.sort(
                  (a, b) => b.timestamp - a.timestamp
                );

                if (areaEqsEventsFlat.length !== get().areaEqsEvents.length) {
                  set(
                    produce((state: any) => {
                      state.areaEqsEvents = areaEqsEventsFlatSorted;
                    })
                  );
                }
              }
            }
          }
        }

        if (topic === get().clientId + "/kpis") {
          // Step 2: Convert the Uint8Array buffer to a string
          const jsonString = new TextDecoder().decode(log);

          // Step 3: Parse the JSON string into a JavaScript object
          const jsonObject = JSON.parse(jsonString);

          set(
            produce((state: any) => {
              state.getKpisData = jsonObject;
            })
          );
        }
      });
      // Error callback
      client.on("error", (err) => {
        console.error("Connection error: ", err);
      });
    } catch (error) {
      console.error("Error connecting to MQTT broker:", error);
    }
  },
  disConnectWebMQTT: async () => {
    try {
      // Cleanup on component unmount
      return async () => {
        if (brokerConnectionClient) {
          brokerConnectionClient.unsubscribe(get().clientId + "/events");
          brokerConnectionClient.unsubscribe(get().clientId + "/kpis");
          brokerConnectionClient.endAsync(); // Disconnect the client
          console.log("MQTT client disconnected");
        }
      };
    } catch (error) {
      console.error("Error disconnecting to MQTT broker:", error);
    }
  },

  loadEquipmentDetails: async (equipmentNodeId: string, lang?: string) => {
    try {
      if (get().isLoggedIn === true) {
        if (lang === undefined) {
          lang = get().lang;
        }

        const encodedEquipmentNodeId = encodeURIComponent(equipmentNodeId);

        const response = await Axios.get(
          `api/v1/equipments/${encodedEquipmentNodeId}?lang=${lang}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response && response?.status === 200) {
          set(
            produce((state: any) => {
              state.subscribedEquipments = response.data;
            })
          );
          return response.data;
        } else {
          throw new Error();
        }
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  setEventsTimeRange: (value: boolean, startTime: number, endTime: number) => {
    set(
      produce((state: any) => {
        state.eventsTimeRange = value;
      })
    );

    set(
      produce((state: any) => {
        state.startTime = startTime;
      })
    );

    set(
      produce((state: any) => {
        state.endTime = endTime;
      })
    );
  },

  clearMachine: async () => {
    set({ subscribedEquipments: {} });
  },
  setareaEqsEvents: (events: any) => {
    set(
      produce((state: any) => {
        state.areaEqsEvents = events;
      })
    );
  },

  getAreaEqsEvents: async (
    nodeids: any,
    startTimeStamp: number,
    endTimeStamp: number
  ) => {
    let allEvents: any = [];
    try {
      if (get().isLoggedIn === true) {
        if (nodeids.length === 0) {
          // Handle undefined equipmentnodeid
          console.warn("Equipment Node ID is undefined");
          return;
        }

        const objNodeIds = {
          equipmentnodeids: nodeids,
          lang: get().lang,
          startTimeStamp,
          endTimeStamp,
        };
        const response: any = await Axios.post(`api/v1/events`, objNodeIds, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            return res;
          })
          .catch((err) => {
            return false;
          });

        // Check if the response object has a status property

        if (response && Object.keys(response).length) {
          if (response?.status === 200 && response?.data !== undefined) {
            allEvents = response.data.length
              ? response.data.map((eq: any) => {
                  return eq.equipment
                    ? eq.equipment.haseventlog &&
                        eq.equipment.haseventlog.map((haseventlog: any) => {
                          return haseventlog.eventlog.events.map(
                            (log: any, index: any) => {
                              const event = {
                                id: log[1],
                                date: moment(log[0]).format(
                                  "DD.MM.YYYY / HH:mm:ss"
                                ),
                                timestamp: log[0],
                                description: log[5],
                                meldungType: log[2] + " (" + log[3] + ")",
                                interner: eq?.equipment?.name,
                                bereich:
                                  eq?.equipment?.isequipmentof?.[0]?.area?.name,
                                productionaline: log[9],
                                status: log[4],
                                equipmentNodeId: eq.equipment.nodeid,
                                eventlogNodeId: haseventlog.eventlog.nodeid,
                                eventIndex: index,
                              };
                              return event;
                            }
                          );
                        })
                    : [];
                })
              : [];

            allEvents = allEvents.filter(function (element: any) {
              return element !== undefined;
            });

            const areaEqsEventsFlat: any[] = allEvents.flat().flat();
            const areaEqsEventsFlatSorted = areaEqsEventsFlat.sort(
              (a, b) => b.timestamp - a.timestamp
            );

            if (areaEqsEventsFlat.length !== get().areaEqsEvents.length) {
              //sort by timestamp

              set({ areaEqsEvents: areaEqsEventsFlatSorted });
              set({ allEventsRaw: response.data });
            }
          } else {
            // Handle other status codes if needed
            throw new Error(`Unexpected status code: ${response}`);
          }
        }
      }
    } catch (error) {
      // Handle errors, log, or rethrow if needed
      console.error("Error fetching events:", error);
      throw new Error(String(error));
    }
  },

  deleteEvents: async (
    events: {
      equipmentnodeid: string;
      eventlognodeid: string;
      eventindex: number;
    }[]
  ) => {

    const response: any = await Axios.post(
      `api/v1/events/delete`,
      { events },
      { headers: { "Content-Type": "application/json" } }
    );
    if (response?.status < 200 || response?.status >= 300) {
      throw new Error(`Unexpected status code: ${response?.status}`);
    }
  },

  emptyEvents: async () => {
    try {
      set(
        produce((state: any) => {
          state.subscribedEvents = [];
        })
      );
    } catch (error) {
      // Handle errors, log, or rethrow if needed
      console.error("Error fetching events:", error);
      throw new Error(String(error));
    }
  },

  //Start of eqConfig
  createEqConfig: async (payload: any) => {
    if (payload.lang === undefined) {
      payload.lang = get().lang;
    }

    const commandObjects: any[] = [];

    const eqCommand: any = {
      nodeId: payload.nodeid ? payload.nodeid : "",
      payload: payload,
      type: "create",
      task: "processCreateEqConfigCommand",
    };

    const attachmentCommandObjects = [];

    if (payload.attachments?.length > 0) {
      for (const item of payload.attachments) {
        const attachment = item.attachment;
        if (attachment.nodeid === undefined || attachment.nodeid === null) {
          attachment.nodeid = new NodeId("mesutronic.de", uuidv4()).toUrl();
        }

        const attachmentPayload = {
          isattachmentof: payload.isattachmentof,
          lang: payload.lang,
          nodeid: attachment.nodeid,
          file: attachment.file,
          specifier: "",
        };
        const fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        const attachmentCommandObject = {
          parentNodeIds: [payload.nodeid],
          nodeId: attachment.nodeid,
          payload: attachmentPayload,
          filesToUpload: [fileToUpload],
          type: "create",
          task: "processCreateAttachmentCommand",
        };
        attachmentCommandObjects.push(attachmentCommandObject);
      }
    }

    commandObjects.push(eqCommand, ...attachmentCommandObjects);

    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  //Start of siteConfig
  deleteEqConfig: async (payload: any) => {
    if (payload.nodeid === undefined) {
      return;
    }

    const commandObjects: any[] = [];

    const eqCommand: any = {
      nodeId: payload.nodeid ? payload.nodeid : "",
      payload: payload,
      type: "delete",
      task: "processDeleteEqConfigCommand",
    };
    commandObjects.push(eqCommand);

    const promises = await get().enqueueCommands(commandObjects);

    return promises;
  },

  processDeleteEqConfigCommand: async (commandObject: any) => {
    try {
      const encodedNotificationNodeId = encodeURIComponent(
        commandObject.nodeId
      );

      const response = await Axios.delete(
        `/api/v1/equipments/${encodedNotificationNodeId}`,
        {
          data: {
            legalentitynodeid: commandObject.legalentitynodeid,
          },
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  processCreateEqConfigCommand: async (commandObject: any) => {
    try {
      const response = await Axios.post(
        "api/v1/equipments",
        commandObject.payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        return response.data;
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  processsGetlebrty: async (commandObject: any) => {
    try {
      const response = await Axios.get(
        "api/v1/getlebrty?includeBrands=true&&includeTypes=true",
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );

      if (response && response?.status === 200) {
        let types: any = [];
        if (response.data) {
          response.data.map((data: any) => {
            return data.legalentity.hasbrand.map((br: any) => {
              if (
                br.brand.nodeid ===
                "247fn://247uptime.io/914c26c1-84c4-40fb-b5ff-5ca87b5df9d1"
              ) {
                types.push(data);
              }
            });
          });
        }
        set(
          produce((state: any) => {
            state.brandTypes = types;
          })
        );
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },

  updateEquipment: async (payload: any) => {
    await get().pauseCommandQueue();
    let promises;
    const commandObjects: any = [];
    const attachmentCommandObjects: any = [];
    let filesToUpload;

    if (Array.isArray(payload.image)) {
      if (payload.image[0]?.attachment) {
        const attachment = payload.image[0]?.attachment;
        attachment.nodeid = payload.nodeid;

        let fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        filesToUpload = [fileToUpload];
      }
    }
    if (Array.isArray(payload.typenameplate)) {
      if (payload.typenameplate[0]?.attachment) {
        const attachment = payload.typenameplate[0]?.attachment;
        attachment.nodeid = payload.nodeid;

        let fileToUpload = _.cloneDeep(attachment);
        fileToUpload.property = "file";
        filesToUpload = [fileToUpload];
      }
    }

    const updateCommandObject = {
      parentNodeIds: [payload.equipmentnodeid],
      filesToUpload: filesToUpload,
      nodeId: payload.equipmentnodeid,
      payload: payload,
      type: "update",
      task: "processUpdateEquipmentCommand",
    };
    commandObjects.push(updateCommandObject, ...attachmentCommandObjects);

    promises = get().enqueueCommands(commandObjects);
    // update the notification in the state

    get().resumeCommandQueue();

    return promises;
  },

  processUpdateEquipmentCommand: async (commandObject: any) => {
    try {
      if (get().isLoggedIn === true) {
        const encodedNotificationNodeId = encodeURIComponent(
          commandObject.payload.nodeid
        );
        const response = await Axios.put(
          `/api/v1/equipments/${encodedNotificationNodeId}`,
          commandObject.payload,
          {
            headers: {
              "Content-Type": "application/json",
              //Authorization: "Bearer " + this.accessToken,
            },
            timeout: 10000,
          }
        );

        if (response && response?.status === 200) {
          return;
        } else {
          throw new Error();
        }
      } else {
        throw new Error();
      }
    } catch (error) {
      throw new Error(String(error));
    }
  },
  updateEquipmentInState: (equipment: any) => {
    set(
      produce((state: any) => {
        // update in subscribedEquipments
        // get the previous state
        const equipmentTarget = state.subscribedEquipments[equipment?.nodeid];

        const updatedEquipment = Object.assign(
          equipmentTarget && equipmentTarget,
          equipment
        );
        state.subscribedEquipments[equipment?.nodeid] = updatedEquipment;
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipment.nodeid];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateAddNotification: (notification: any) => {
    //let equipment;

    set(
      produce((state: any) => {
        //add to subscribedEquipments
        const equipment =
          state.subscribedEquipments[
            notification.isnotificationof[0].equipment.nodeid
          ];
        if (equipment.hasnotification === undefined) {
          equipment.hasnotification = [];
        }

        equipment.hasnotification.push({ notification: notification });

        state.subscribedEquipments[equipment.nodeid] = equipment;
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[
        notification.isnotificationof[0].equipment.nodeid
      ];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateUpdateNotification: (notification: any) => {
    //let equipment;

    set(
      produce((state: any) => {
        //update in subscribedEquipments
        const equipment =
          state.subscribedEquipments[
            notification.isnotificationof[0].equipment.nodeid
          ];

        if (equipment.hasnotification === undefined) {
          equipment.hasnotification = [];
          equipment.hasnotification.push({ notification: notification });
        } else {
          const notificationIndex = equipment.hasnotification.findIndex(
            (item: any) => item.notification.nodeid === notification.nodeid
          );
          if (notificationIndex >= 0) {
            equipment.hasnotification[notificationIndex] = {
              notification: notification,
            };
          }
        }
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[
        notification.isnotificationof[0].equipment.nodeid
      ];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateDeleteNotification: (
    equipmentNodeId: string,
    notificationNodeId: string
  ) => {
    //let equipment;

    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        const equipment = state.subscribedEquipments[equipmentNodeId];

        const notificationIndex = equipment.hasnotification.findIndex(
          (item: any) => item.notification.nodeid === notificationNodeId
        );
        if (notificationIndex >= 0) {
          equipment.hasnotification.splice(notificationIndex, 1);
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateAddAttachment: (
    attachmentOfNodeId: string,
    attachment: string
  ) => {
    set(
      produce((state: any) => {
        //update in notificationDetails
        const equipment = state.subscribedEquipments[attachmentOfNodeId];
        if (equipment.hasattachment === undefined) {
          equipment.hasattachment = [];
          equipment.hasattachment.push({ attachment: attachment });
        } else {
          equipment.hasattachment.push({ attachment: attachment });
        }
      })
    );
  },
  updateEquipmentInStateRemoveAttachment: (
    equipmentNodeId: string,
    attachmentNodeId: string
  ) => {
    //let equipment;

    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        const equipment = state.subscribedEquipments[equipmentNodeId];

        const attachmentIndex = equipment.hasattachment.findIndex(
          (item: any) => item.attachment.nodeid === attachmentNodeId
        );
        if (attachmentIndex >= 0) {
          equipment.hasattachment.splice(attachmentIndex, 1);
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateUpdateAttachment: (
    equipmentNodeId: string,
    attachment: Record<string, any>
  ) => {
    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        const equipment = state.subscribedEquipments[equipmentNodeId];

        const attachmentIndex = equipment.hasattachment.findIndex(
          (item: any) => item.attachment.nodeid === attachment.attachmentnodeid
        );
        if (attachmentIndex >= 0) {
          equipment.hasattachment[attachmentIndex].attachment.description =
            attachment.description;
          equipment.hasattachment[attachmentIndex].attachment.title =
            attachment.title;
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateFaqInStateRemoveAttachment: (
    attachmentOfNodeId: string,
    attachmentNodeId: string,
    equipmentNodeId: string
  ) => {
    //let equipment;

    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        const equipment = state.subscribedEquipments[equipmentNodeId];

        const filterAarray = equipment.hasquestionanswer.filter(
          (item: any) => item.questionanswer.nodeid === attachmentOfNodeId
        );
        const attachmentIndex =
          filterAarray.questionanswer?.hasattachment.findIndex(
            (item: any) => item?.attachment?.nodeid === attachmentNodeId
          );

        if (attachmentIndex >= 0) {
          filterAarray.questionanswer?.hasattachment.splice(attachmentIndex, 1);
        }
      })
    );
    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateAddFaq: (questionanswer: Record<string, any>) => {
    //let equipment;

    set(
      produce((state: any) => {
        //add to subscribedEquipments
        const equipment =
          state.subscribedEquipments[
            questionanswer.isfaqof[0].equipment.nodeid
          ];
        if (equipment.hasquestionanswer === undefined) {
          equipment.hasquestionanswer = [];
        }

        equipment.hasquestionanswer.push({ questionanswer: questionanswer });

        state.subscribedEquipments[equipment.nodeid] = equipment;
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[questionanswer.isfaqof[0].equipment.nodeid];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateUpdateFaq: (
    questionanswer: Record<string, any>,
    attachment: any
  ) => {
    set(
      produce((state: any) => {
        //update in subscribedEquipments
        const equipment = state.subscribedEquipments[questionanswer.isfaqof];
        if (equipment.hasquestionanswer === undefined) {
          equipment.hasquestionanswer = [];
          equipment.hasquestionanswer.push({ questionanswer: questionanswer });
        } else {
          const questionanswerIndex = equipment.hasquestionanswer.findIndex(
            (item: any) =>
              item.questionanswer.nodeid === questionanswer.questionanswernodeid
          );
          if (questionanswerIndex >= 0) {
            equipment.hasquestionanswer[
              questionanswerIndex
            ].questionanswer.answer = questionanswer.answer;
            equipment.hasquestionanswer[
              questionanswerIndex
            ].questionanswer.question = questionanswer.question;
            equipment.hasquestionanswer[
              questionanswerIndex
            ].questionanswer.nodeid = questionanswer.nodeid;
            if (attachment && attachment[0]?.payload) {
              equipment.hasquestionanswer[
                questionanswerIndex
              ].questionanswer.hasattachment.push({
                attachment: attachment[0].payload,
              });
            }
          }
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[questionanswer.isfaqof];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateAddFaqAttachment: (attachment: any) => {
    set(
      produce((state: any) => {
        //update in notificationDetails
        const equipment = state.subscribedEquipments["attachmentOfNodeId"];
        if (equipment.hasattachment === undefined) {
          equipment.hasattachment = [];
          equipment.hasattachment.push({ attachment: attachment });
        } else {
          equipment.hasattachment.push({ attachment: attachment });
        }
      })
    );
  },
  updateEquipmentInStateDeleteFaq: (
    equipmentNodeId: string,
    questionanswerNodeId: string
  ) => {
    //let equipment;

    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        const equipment = state.subscribedEquipments[equipmentNodeId];

        const questionanswerIndex = equipment.hasquestionanswer.findIndex(
          (item: any) => item.questionanswer.nodeid === questionanswerNodeId
        );
        if (questionanswerIndex >= 0) {
          equipment.hasquestionanswer.splice(questionanswerIndex, 1);
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateAddCounter: (counter: Record<string, any>) => {
    //let equipment;

    set(
      produce((state: any) => {
        //add to subscribedEquipments
        const equipment =
          state.subscribedEquipments[counter.iscounterof[0].equipment.nodeid];
        if (equipment.hascounter === undefined) {
          equipment.hascounter = [];
        }

        equipment.hascounter.push({ counter: counter });

        state.subscribedEquipments[equipment.nodeid] = equipment;
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[counter.iscounterof[0].equipment.nodeid];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateUpdateCounter: (counter: Record<string, any>) => {
    //let equipment;

    set(
      produce((state: any) => {
        //update in subscribedEquipments
        const equipment = state.subscribedEquipments[counter.equipmentNodeId];
        if (equipment.hascounter === undefined) {
          equipment.hascounter = [];
          equipment.hascounter.push({ counter: counter });
        } else {
          const counterIndex = equipment.hascounter.findIndex(
            (item: any) => item.counter.nodeid === counter.nodeid
          );
          if (counterIndex >= 0) {
            equipment.hascounter[counterIndex]["counter"] = counter;
          }
        }
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[counter.equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateUpdateCounterValue: (counter: Record<string, any>) => {
    set(
      produce((state: any) => {
        //update in subscribedEquipments
        const equipment = state.subscribedEquipments[counter.equipmentNodeId];
        if (equipment.hascounter === undefined) {
          equipment.hascounter = [];
          equipment.hascounter.push({ counter: counter });
        } else {
          const counterIndex = equipment.hascounter.findIndex(
            (item: any) => item.counter.nodeid === counter.nodeid
          );
          if (counterIndex >= 0) {
            equipment.hascounter[counterIndex].counter?.values.push(
              counter.values
            );
          }
        }
      })
    );

    const updatedEquipment =
      get().subscribedEquipments[counter.equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
  updateEquipmentInStateDeleteCounter: (
    equipmentNodeId: string,
    counterNodeId: string
  ) => {
    set(
      produce((state: any) => {
        //delete in subscribedEquipments
        let equipment: Record<string, any> =
          state.subscribedEquipments[equipmentNodeId];

        const counterIndex = equipment.hascounter.findIndex(
          (item: any) => item.counter.nodeid === counterNodeId
        );
        if (counterIndex >= 0) {
          equipment.hascounter.splice(counterIndex, 1);
        }
      })
    );

    const updatedEquipment = get().subscribedEquipments[equipmentNodeId];

    get().updateTopologyInStateUpdateEquipment(updatedEquipment);
  },
});

export default createEquipmentSlice;
